import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "navbar navbar-expand-lg navbar-dark bg-dark" };
const _hoisted_2 = { class: "container-fluid" };
const _hoisted_3 = {
    class: "navbar-brand",
    href: "/"
};
const _hoisted_4 = {
    class: "collapse navbar-collapse",
    id: "navbarNavDropdown"
};
const _hoisted_5 = { class: "navbar-nav me-auto" };
const _hoisted_6 = { class: "navbar-nav" };
const _hoisted_7 = {
    key: 0,
    class: "nav-item dropdown"
};
const _hoisted_8 = {
    class: "nav-link dropdown-toggle",
    href: "#",
    id: "nav-system__options",
    role: "button",
    "data-bs-toggle": "dropdown",
    "aria-expanded": "false"
};
const _hoisted_9 = {
    class: "dropdown-menu dropdown-menu-end text-end",
    "aria-labelledby": "nav-system__options"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_intranet_layout__navbar_item = _resolveComponent("g-intranet-layout__navbar-item");
    const _component_portal_target = _resolveComponent("portal-target");
    return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.$appHost.config.title), 1),
            _cache[0] || (_cache[0] = _createElementVNode("button", {
                class: "navbar-toggler",
                type: "button",
                "data-bs-toggle": "collapse",
                "data-bs-target": "#navbarNavDropdown",
                "aria-controls": "navbarNavDropdown",
                "aria-expanded": "false",
                "aria-label": "Toggle navigation"
            }, [
                _createElementVNode("span", { class: "navbar-toggler-icon" })
            ], -1)),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("ul", _hoisted_5, [
                    (_ctx.mainMenuEntriesLeft && _ctx.mainMenuEntriesLeft.length > 0)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.mainMenuEntriesLeft, (menuItem) => {
                            return (_openBlock(), _createBlock(_component_g_intranet_layout__navbar_item, { "menu-item": menuItem }, null, 8, ["menu-item"]));
                        }), 256))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("ul", _hoisted_6, [
                    (_ctx.hasPortalOptions)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                            _createElementVNode("a", _hoisted_8, _toDisplayString(_ctx.$t('client.Layout.Menu.Options')), 1),
                            _createElementVNode("ul", _hoisted_9, [
                                _createVNode(_component_portal_target, {
                                    name: "menu-main__options",
                                    multiple: ""
                                })
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.mainMenuEntriesRight && _ctx.mainMenuEntriesRight.length > 0)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.mainMenuEntriesRight, (menuItem) => {
                            return (_openBlock(), _createBlock(_component_g_intranet_layout__navbar_item, {
                                "menu-item": menuItem,
                                align: "right"
                            }, null, 8, ["menu-item"]));
                        }), 256))
                        : _createCommentVNode("", true)
                ])
            ])
        ])
    ]));
}
